import { BookingState } from "@/app/models/booking-state"
import { BookingModel } from "@/app/models/booking.model"
import { Ref, ref } from "@vue/composition-api"
import { api } from "../../api"
import { useCallbacksTCS } from "../merchant-callbacks/callbacks-tcs.reactive"

export function useCancelBooking() {
  const isCancelBookingPending = ref(false)
  const { callbacks } = useCallbacksTCS()

  async function cancelBooking(booking: Ref<BookingModel>): Promise<void> {
    isCancelBookingPending.value = true
    const response = await api.cancelBooking(booking.value.referenceId)

    if (response.wasSuccessful && response.data) {
      booking.value.state = BookingState.Deleted

      // Notify the webview frontend
      callbacks.close()
    } else {
      callbacks.error()
    }

    isCancelBookingPending.value = false
  }

  return { cancelBooking, isCancelBookingPending }
}
